'use strict';

require('babel-register');

var eventBus = require('./eventBus');

module.exports = eventBus;


//////////////////
// WEBPACK FOOTER
// ../~/event-bus-rx/lib/index.js
// module id = 49
// module chunks = 0